// website/app/common/category-cards/CategoryCard.jsx
import React, { Component } from 'react';
import { Cell, palm } from 'react-flexr';
import StyleSheet from 'stilr';
import { withRouter } from 'react-router-dom';
import { FAIcon } from '../icons';
import Rating from '../results/result-row/common/rating';

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    marginBottom: '1em'
  },
  box: {
    background: '#ffffff',
    paddingTop: 11,
    paddingBottom: 11,
    border: '1px solid #cccccc',
    textAlign: 'center',
    width: '100%',
    position: 'relative',
    color: '#666',
    fontSize: 16,

    ':hover': {
      borderColor: '#2196F3',
      cursor: 'pointer'
    },

    [palm]: {
      paddingTop: 5,
      paddingBottom: 5
    }
  },

  iconContainer: {
    color: '#2196F3',
    marginTop: 5,
    textAlign: 'center',

    [palm]: {
      position: 'absolute',
      top: '50%',
      marginTop: -16,
      left: '1em',
      lineHeight: 1,
      marginBottom: 0,
      width: '40'
    }
  },

  title: {
    fontWeight: 'bold',
    fontSize: 20,
    marginTop: 5,
    marginBottom: -2
  }
});

class CategoryCard extends Component {
  onClick = () => {
    this.props.history.push(this.props.link);
  };

  render() {
    const { icon, title, text } = this.props;

    return (
      <Cell size="1/3" lap="1/2" palm="1/1" className={styles.container}>
        <div className={styles.box} onClick={this.onClick}>
          <div className={styles.iconContainer}>{FAIcon(icon, { style: { fontSize: 30, ...this.props.style} })}</div>
          <div>
            <h4 className={styles.title}>{title}</h4>
            {text}
          </div>
        </div>
      </Cell>
    );
  }
}

export default withRouter(CategoryCard);
